<template>
  <div class="connection-error">
    <div class="icon">⚠️</div>
    <h3>Can't reach the server</h3>
    <p>
      We couldn't connect to the R3 service. Check your internet connection,
      then try again. If the problem continues, the service may be down for
      maintenance.
    </p>
    <DxButton text="Try Again" type="default" styling-mode="contained" icon="refresh" width="100%"
      @click="tryAgain" />
  </div>
</template>

<script>
import { DxButton } from "devextreme-vue/button";
import { useRoute, useRouter } from "vue-router";

const FALLBACK = "/reporting/containers-status";

export default {
  components: { DxButton },
  setup() {
    const route = useRoute();
    const router = useRouter();

    // Back to the page the user was on; if the server is still unreachable
    // the session guard brings them straight back here.
    function tryAgain() {
      const target = route.query.redirect;
      router.replace(typeof target === "string" && target ? target : FALLBACK);
    }

    return { tryAgain };
  },
};
</script>

<style scoped>
.connection-error {
  text-align: center;
  padding: 8px 0 4px;
}

.icon {
  font-size: 40px;
  line-height: 1;
  margin-bottom: 12px;
}

h3 {
  margin: 0 0 12px;
}

p {
  margin: 0 0 24px;
  opacity: 0.8;
  line-height: 1.5;
}
</style>
